import Chat from "../../../../content/blog/Chat";
import * as React from 'react';
export default {
  Chat,
  React
};